import classes from "./LabelValue.module.css";
import clsx from "clsx";
const LabelValue = ({
  value="ACNCC",
  label,
  className,
  labelClass,
  valueClass,
  LabelTag = "h2",
  ValueTag = "p",
  children
}) => {
  return (
    <div className={clsx(classes.wrapper,className)}>
      <LabelTag className={clsx(labelClass, classes.heading)}>{label}</LabelTag>

      <ValueTag className={valueClass}>{value}</ValueTag>
      {children}
    </div>
  );
};

export default LabelValue;
